module.exports = __webpack_public_path__ + "img/history.70d022ad.svg";